import { Badge } from "@/components/ui/badge";
import { LeaveStatus } from "@/types";
import { CheckCircle2, Clock, XCircle } from "lucide-react";

interface StatusBadgeProps {
  status: LeaveStatus;
}

export function StatusBadge({ status }: StatusBadgeProps) {
  const config = {
    PENDING: {
      label: "Pending",
      icon: Clock,
      className:
        "bg-warning/10 text-warning border-warning/20 hover:bg-warning/20",
    },
    APPROVED: {
      label: "Approved",
      icon: CheckCircle2,
      className:
        "bg-success/10 text-success border-success/20 hover:bg-success/20",
    },
    REJECTED: {
      label: "Rejected",
      icon: XCircle,
      className:
        "bg-destructive/10 text-destructive border-destructive/20 hover:bg-destructive/20",
    },
    DRAFT: {
      label: "Pending",
      icon: Clock,
      className:
        "bg-muted/10 text-muted-foreground border-muted/20 hover:bg-muted/20",
    },
    CANCELLED: {
      label: "Cancelled",
      icon: XCircle,
      className:
        "bg-muted/10 text-muted-foreground border-muted/20 hover:bg-muted/20",
    },
  };

  const { label, icon: Icon, className } = config[status];

  return (
    <Badge variant="outline" className={className}>
      <Icon className="h-3 w-3 mr-1" />
      {label}
    </Badge>
  );
}
